import script from "./SingleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleCard.vue?vue&type=script&setup=true&lang=ts"

import "./SingleCard.vue?vue&type=style&index=0&id=bbd04d8c&lang=css"

const __exports__ = script;

export default __exports__